import { Star } from "lucide-react";

export const StarPicker = ({ value, onChange, prefix }) => (
  <div className="flex gap-1" role="radiogroup" aria-label="Rating">
    {[1, 2, 3, 4, 5].map((n) => (
      <button
        key={n}
        type="button"
        role="radio"
        aria-checked={value === n}
        onClick={() => onChange(n)}
        className="grid h-12 w-12 place-items-center rounded-md transition-colors hover:bg-zinc-800"
        aria-label={`${n} star${n > 1 ? "s" : ""}`}
        data-testid={`${prefix}-star-${n}`}
      >
        <Star className={`h-8 w-8 ${n <= value ? "fill-[#FFD23F] text-[#FFD23F]" : "text-zinc-600"}`} />
      </button>
    ))}
  </div>
);
